var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPatternTitle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "119.438px",
    height: "776px",
    viewBox: "1 0 119.438 776",
    enableBackground: "new 1 0 119.438 776",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.05,
    stroke: "#898B8E"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 1.6664,
    strokeMiterlimit: 10,
    d: "M60.721,60.708L1.004,120.425l59.716,59.716   l59.717-59.716L60.721,60.708z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 1.6664,
    strokeMiterlimit: 10,
    d: "M60.718,119.172L1.002,178.888l59.716,59.716   l59.717-59.716L60.718,119.172z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 1.6664,
    strokeMiterlimit: 10,
    d: "M60.722,179.971L1.005,239.687l59.716,59.716   l59.716-59.716L60.722,179.971z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 1.6664,
    strokeMiterlimit: 10,
    d: "M60.719,238.435L1.003,298.151l59.716,59.716   l59.716-59.716L60.719,238.435z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 1.6664,
    strokeMiterlimit: 10,
    d: "M60.721,298.569L1.005,358.286l59.716,59.716   l59.716-59.716L60.721,298.569z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 1.6664,
    strokeMiterlimit: 10,
    d: "M60.719,357.033L1.002,416.749l59.716,59.716   l59.717-59.716L60.719,357.033z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 1.6664,
    strokeMiterlimit: 10,
    d: "M60.717,417.827L1.001,477.543l59.716,59.716   l59.716-59.716L60.717,417.827z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 1.6664,
    strokeMiterlimit: 10,
    d: "M60.72,476.295L1.003,536.012l59.716,59.717   l59.716-59.717L60.72,476.295z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 1.6664,
    strokeMiterlimit: 10,
    d: "M60.716,536.425L1,596.142l59.716,59.717   l59.715-59.717L60.716,536.425z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 1.6664,
    strokeMiterlimit: 10,
    d: "M60.719,594.894L1.003,654.61l59.716,59.717   l59.716-59.717L60.719,594.894z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 1.6664,
    strokeMiterlimit: 10,
    d: "M60.999,655.714V596"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 1.6664,
    strokeMiterlimit: 10,
    d: "M60.999,536.714V477"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 1.6664,
    strokeMiterlimit: 10,
    d: "M60.999,417.714V358"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 1.6664,
    strokeMiterlimit: 10,
    d: "M60.999,298.714V239"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 1.6664,
    strokeMiterlimit: 10,
    d: "M60.717,655.689L1.001,715.405l59.716,59.716   l59.716-59.716L60.717,655.689z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 1.6664,
    strokeMiterlimit: 10,
    d: "M60.751,774.439v-59.715"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 1.6664,
    strokeMiterlimit: 10,
    d: "M60.721,0.708L1.004,60.425l59.716,59.716   l59.717-59.716L60.721,0.708z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 1.6664,
    strokeMiterlimit: 10,
    d: "M60.751,60.455V0.741"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 1.6664,
    strokeMiterlimit: 10,
    d: "M60.751,179.64v-59.722"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatternTitle);
export default __webpack_public_path__ + "static/media/pattern-title.1452bb76ba4b5b8dfa7ce1ef044e79b0.svg";
export { ForwardRef as ReactComponent };